export default __webpack_public_path__ + "static/media/graphcool.98bc681f.svg";